const state = {};

const getters = {};

const actions = {
    async endorseItem({ commit }, data) { 
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append(`ids`, JSON.stringify(data.ids));
            formData.append(`status`, data.status);
            if(data.attachments && data.attachments.length) {
                for( var i = 0; i < data.attachments.length; i++ ){
                    let item = data.attachments[i];
                    formData.append(`files[${i}]`, item.file);
                    formData.append('reference_id', item.reference_id);
                }
            }
            global.axios.post(`api/lmu-adhoc/dorj/endorse`, formData)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}